import React from 'react';

/**
 * The `SidenavSection` component is used to display a section of the sidenav.
 * All `SidenavItem` components should be nested within a `SidenavSection`.
 *
 * If the `label` prop is provided, it will be used to generate a header for the section, and the section will be labelled by the `aria-labelledby` attribute.
 */
function SidenavSection({ children, className, label, subnav, }) {
    const subnavProps = subnav ? { slot: "subnav" } : {};
    return (React.createElement("tds-sidenav-section", { class: className, label: label, ...subnavProps }, children));
}

export { SidenavSection };
//# sourceMappingURL=SidenavSection.js.map
